var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4429 15.8134L15.1279 18.5029L12.4414 21.1932L13.5034 22.2529L17.2534 18.5029L13.5034 14.7529L12.4429 15.8134Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6929 15.8134L20.3779 18.5029L17.6914 21.1932L18.7534 22.2529L22.5034 18.5029L18.7534 14.7529L17.6929 15.8134Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3493 5.75L12 10.838L4.6515 5.75H19.3493ZM10.5 17.75H3L2.99775 6.4295L11.5732 12.3665C11.7015 12.4558 11.8507 12.5 12 12.5C12.15 12.5 12.2985 12.4558 12.4275 12.3665L21.0007 6.43175L21 13.25H22.5V5.75C22.5 4.92275 21.8272 4.25 21 4.25H3C2.1735 4.25 1.5 4.9205 1.5 5.747V17.75C1.5 18.5773 2.1735 19.25 3 19.25H10.5V17.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/follow-up.f52827c5003d85d2fb18fc49f7c832dd.svg";
export { ForwardRef as ReactComponent };